import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import { ButtonToolbar } from 'reactstrap';

import TradeListDatePicker from './TradeListDatePicker';
import TradeListDisabledFilterPlaceholder from './TradeListDisabledFilterPlaceholder';
import TradeListFilters from './TradeListFilters';

/**
 * Control/Filter component for the trade list table
 * @param {object} root0
 * @param {DateTime} root0.date - date selected (to view the trades)
 * @param {Function} root0.dateUpdateFunc - to update the user date selection
 * @param {object} root0.filter - object contains tradeDirection and tradeType
 * @param {Function} root0.filterFunc - update the filter selection
 * @param {Error} root0.error - error object
 * @param {boolean} root0.isModalOpen - indicate whether the loading modal is open or not
 * @returns {React.ReactComponentElement} -TradeListControls component
 */
function TradeListControls({
  date, dateUpdateFunc, error, filter, filterFunc, isModalOpen,
}) {
  return (
    <div className="trade-history-filters">
      <ButtonToolbar>
        {error ? <TradeListDisabledFilterPlaceholder />
          : <TradeListFilters filter={filter} filterFunc={filterFunc} />}

        <TradeListDatePicker
          date={date}
          dateUpdateFunc={dateUpdateFunc}
          isModalOpen={isModalOpen}
        />
      </ButtonToolbar>
    </div>
  );
}

TradeListControls.propTypes = {
  date: PropTypes.instanceOf(DateTime).isRequired,
  dateUpdateFunc: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    direction: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  filterFunc: PropTypes.func.isRequired,
  error: PropTypes.instanceOf(Error),
  isModalOpen: PropTypes.bool,
};
TradeListControls.defaultProps = {
  isModalOpen: false,
  error: null,
};
export default TradeListControls;
